import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-loading-spinner-extended-white-background',
  templateUrl: './loading-spinner-extended-white-background.component.html',
  imports: [TranslateDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Add this line to ignore errors related to the dotlottie-player
})
export class LoadingSpinnerExtendedWhiteBackgroundComponent {
  @Input() loadingSpinnerText: string;
}
